const UserPermission = () =>
  import(
    /* webpackChunkName: "user-users" */ '@/pages/user/security/user/permission/index.vue'
  )
const UserLicence = () =>
  import(
    /* webpackChunkName: "user-users" */ '@/pages/user/security/user/licence/index.vue'
  )

const UserLimitLicense = () =>
  import(
    /* webpackChunkName: "user-users" */ '@/pages/user/security/user/limit-license/index.vue'
  )

const UserLimit = () =>
  import(
    /* webpackChunkName: "user-users" */ '@/pages/user/security/user/limit/index.vue'
  )

const UserGeneralLimit = () =>
  import(
    /* webpackChunkName: "user-securiy-general" */ '@/pages/user/security/user/general/index.vue'
  )

export default {
  path: 'security',
  meta: { label: 'UserSecurity' },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'UserSecurityPermission',
      path: 'permissions/:id',
      meta: { label: 'Edit' },
      component: UserPermission,
      props: true
    },
    {
      name: 'UserSecurityLicense',
      path: 'license/:id',
      meta: { label: 'Edit' },
      component: UserLicence,
      props: true
    },
    {
      name: 'UserSecurityLimitLicense',
      path: 'limit-license/:id',
      meta: { label: 'Edit' },
      component: UserLimitLicense,
      props: true
    },
    {
      name: 'UserSecurityLimit',
      path: 'limit/:id',
      meta: { label: 'Edit' },
      component: UserLimit,
      props: true
    },
    {
      name: 'UserSecurityGeneralLimit',
      path: 'limit',
      meta: { label: 'Edit' },
      component: UserGeneralLimit,
      props: true
    }
  ]
}
